import { render, staticRenderFns } from "./localized-home.vue?vue&type=template&id=e8a8b506&scoped=true"
import script from "./localized-home.vue?vue&type=script&lang=js"
export * from "./localized-home.vue?vue&type=script&lang=js"
import style0 from "./localized-home.vue?vue&type=style&index=0&id=e8a8b506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a8b506",
  null
  
)

export default component.exports